<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-file-alt"></i> Host Institution Details</h4>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="managementForm">
      <div class="row">
        <div class="col-12 p-3">
          <p class="sub-title">Institution Details</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Name of the Institution / Organization<span class="text-danger"
                  >*</span
                ></mat-label
              >
              <input
                matInput
                placeholder="Enter Name of the Institution / Organization"
                formControlName="name"
                readonly="{{ showForm }}"
              />
              <mat-error *ngIf="setting.name.touched && setting.name.errors">
                <span *ngIf="setting.name.errors.required"
                  >Name of the Institution / Organization is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Total Number of Academic Departments<span class="text-danger"
                  >*</span
                ></mat-label
              >
              <input
                matInput
                placeholder="Enter Total Number of Academic Departments"
                formControlName="totaldepartments"
                oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                maxlength="5"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="
                  setting.totaldepartments.touched &&
                  setting.totaldepartments.errors
                "
              >
                <span *ngIf="setting.totaldepartments.errors.required"
                  >Total Number of Academic Departments is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Type of Institution<span class="text-danger"
                  >*</span
                ></mat-label
              >
              <mat-select
                (selectionChange)="onSelect($event.value)"
                formControlName="type"
                disabled="{{ showForm }}"
              >
                <mat-option value="stateGovt"
                  >Government Institution</mat-option
                >
                <mat-option value="privateInst">Private Institution</mat-option>
                <mat-option value="other">Other (Please Specify)</mat-option>
              </mat-select>
              <mat-error *ngIf="setting.type.touched && setting.type.errors">
                <span *ngIf="setting.type.errors.required"
                  >Type of Institution is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <div *ngIf="selectedOption === 'other'">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Others<span class="text-danger">*</span></mat-label>
                <input
                  matInput
                  placeholder="Enter Other Institution"
                  formControlName="othertype"
                  readonly="{{ showForm }}"
                />
              </mat-form-field>
              <mat-error
                *ngIf="setting.othertype.touched && setting.othertype.errors"
              >
                <span *ngIf="setting.othertype.errors.required"
                  >Other Institution is required</span
                >
              </mat-error>
            </div>
          </div>
        </div>
        <div class="col-12 p-3">
          <p class="sub-title">Address Details</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Address<span class="text-danger">*</span></mat-label>
              <input
                matInput
                placeholder="Enter Address"
                formControlName="address"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="setting.address.touched && setting.address.errors"
              >
                <span *ngIf="setting.address.errors.required"
                  >Address is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>District<span class="text-danger">*</span></mat-label>
              <mat-select
                formControlName="district"
                [ngClass]="{
                  'is-invalid':
                    setting.district.touched && setting.district.errors
                }"
                disabled="{{ showForm }}"
              >
                <mat-option
                  *ngFor="let list of districtdataList"
                  [value]="list"
                >
                  {{ list }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="setting.district.touched && setting.district.errors"
              >
                <span *ngIf="setting.district.errors.required"
                  >District is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Pincode<span class="text-danger">*</span></mat-label>
              <input
                matInput
                placeholder="Enter Pincode"
                type="text"
                formControlName="pincode"
                oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                maxlength="6"
                minlength="6"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="managementForm.get('pincode').hasError('required')"
              >
                Enter Pincode is required
              </mat-error>
              <mat-error
                *ngIf="managementForm.get('pincode').hasError('pattern')"
              >
                <i class="fas fa-exclamation-triangle"></i>
                Invalid Pincode
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-12 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <label
              >Location of the proposed StartupTN Pre-Incubation Centre
              <span class="text-danger">*</span></label
            >
            <div
              *ngIf="
                getValue.overallExperienceStatus != 2 &&
                getValue.overallExperienceStatus != 4 &&
                getValue.overallExperienceStatus != 5 &&
                getValue.overallExperienceStatus != 6
              "
            >
              <div class="mt-3">
                <mat-radio-group
                  formControlName="location"
                  class="example-margin mt-4"
                  aria-label="Select an option"
                  [ngClass]="{
                    'is-invalid':
                      setting.location.touched && setting.location.errors
                  }"
                  disabled="{{ showForm }}"
                >
                  <mat-radio-button value="Urban">Urban</mat-radio-button>
                  <mat-radio-button value="SemiUrban"
                    >Semi - Urban</mat-radio-button
                  >
                  <mat-radio-button value="Rural">Rural</mat-radio-button>
                </mat-radio-group>
                <br />
                <mat-error
                  *ngIf="setting.location.touched && setting.location.errors"
                >
                  <span *ngIf="setting.location.errors.required"
                    >Answer is required</span
                  >
                </mat-error>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-3">
          <p class="sub-title">Contact Details</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Mobile Number <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Institution Mobile Number"
                type="text"
                readonly="{{ showForm }}"
                formControlName="phone"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="10"
                minlength="10"
              />
              <mat-error
                *ngIf="managementForm.get('phone').hasError('required')"
              >
                Mobile Number is required
              </mat-error>
              <mat-error
                *ngIf="managementForm.get('phone').hasError('pattern')"
              >
                <i class="fas fa-exclamation-triangle"></i>
                Invalid Mobile
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Email ID <span class="text-danger">*</span></mat-label>
              <input
                matInput
                formControlName="email"
                placeholder="Enter Institution Email ID"
                readonly="{{ showForm }}"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                type="text"
                (keydown.space)="$event.preventDefault()"
              />
              <mat-error *ngIf="setting.email.touched && setting.email.errors">
                <span *ngIf="setting.email.errors.required"
                  >Email ID is required</span
                >
                <span *ngIf="setting.email.errors.email">
                  <i class="fas fa-exclamation-triangle"></i>
                  Invalid Email
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Website <span class="text-danger">*</span></mat-label>
              <input
                matInput
                formControlName="website"
                placeholder="Enter Institution Website"
                type="text"
                (keydown.space)="$event.preventDefault()"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="setting.website.touched && setting.website.errors"
              >
                <span *ngIf="setting.website.errors.required"
                  >Website is required</span
                >
                <span *ngIf="setting.website.errors.website">
                  <i class="fas fa-exclamation-triangle"></i>
                  Invalid Website
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-5 col-md-4 col-md-12 col-12">
          <div class="form-rows mt-3" *ngIf="!showForm">
            <mat-label
              >Please upload the Copy of the Host Institution’s registration
              certificate. <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input
                class="d-none"
                id="input-file-id"
                type="file"
                (change)="fileUpload($event)"
              />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 10mb)
            </span>
            <p *ngIf="fileErrorShow == true" class="text-danger">
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Certificate</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>Host Institution Registration Certificate is required</span>
            </mat-error>
          </div>

          <div class="form-rows mt-3" *ngIf="showForm" disabled>
            <mat-label
              >Please upload the Copy of the Host Institution’s registration
              certificate. <span class="text-danger">*</span></mat-label
            >
            <label
              *ngIf="disName != '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-primary"
            >
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <label
              *ngIf="disName == '✔ Uploaded'"
              for="input-file-id"
              class="md-button md-raised md-accent"
            >
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 10mb)
            </span>
            <p
              *ngIf="
                logoCheck &&
                selecetdFile &&
                selecetdFile.size / (1024 * 1024) > maxSizeMB
              "
              class="text-danger"
            >
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                >Download & View Certificate</a
              >
            </div>
            <mat-error *ngIf="fileError == true">
              <span>Host Institution Registration Certificate is required</span>
            </mat-error>
          </div>
        </div>
        <div class="col-12 p-3">
          <p class="sub-title">
            Section-8 Details (Applicants other than educational institutions)
          </p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Name of the Section-8 Company:(if already registered)
              </mat-label>
              <input
                matInput
                formControlName="section"
                placeholder="Enter Name of the Section-8 Company"
                type="text"
                (keydown.space)="$event.preventDefault()"
                readonly="{{ showForm }}"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>CIN/Reference Number</mat-label>
              <input
                matInput
                formControlName="cinorref"
                placeholder="Enter CIN/Reference number"
                type="text"
                (keydown.space)="$event.preventDefault()"
                type="text"
                readonly="{{ showForm }}"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="text-center mt-4" *ngIf="!showForm">
        <button mat-raised-button color="primary" (click)="saveBtn()">
          Save
        </button>
      </div>
    </form>
  </div>
</section>
